import { useLocation, Navigate, Outlet } from "react-router-dom";
import useAuth from "../components/hooks/useAuth";

const RequireAuth = ({ allowedRoles }) => {
    const { auth } = useAuth();
    const location = useLocation();

    return (
        // [auth]?.find(role => allowedRoles?.includes(role))
        allowedRoles?.includes(localStorage.getItem('ROLE'))
            ? <Outlet />
                : <Navigate to="/login" state={{ from: location }} replace />
    );
}

export default RequireAuth;